<template lang="pug">
section
  s-page-title(
    :previous='true'
    :title=`
      (id && !$route.query.parentId)
        ? "Редактирование контента"
        : "Добавление контента"
    `
  )
  v-card
    v-tabs(v-model='active' color='dark' slider-color='primary')
      v-tab Описание страницы
      v-tab-item(:transition='false' :reverse-transition='false')
        v-container(grid-list-xl fluid)
          v-layout(wrap)
            v-flex(xs12)
              s-publish-date-status(
                :errors='errors'
                :model='meta'
              )
            v-flex(xs4)
              v-text-field(
                :rules="[$rules.required]"
                v-model='meta.name'
                label='Название'
              )
            v-flex(xs4)
              v-text-field(
                :rules="[$rules.required]"
                v-model='meta.url'
                label='URL'
              )
            v-flex(xs4)
              s-sites-picker(
                v-model='meta.site_id'
                label='Выберите сайт'
              )
            v-flex
              v-select(
                :items='contentTypes.toArray()'
                :returnObject='false'
                :rules="[$rules.required]"
                :value='contentType'
                @change='setContentType'
                item-value='id'
                item-text='name'
                label='Тип создаваемого контента'
              )
            v-flex(xs6 v-if='contentType === contentTypes.JsonData')
              s-jsontemplates-picker(
                :value='meta.site_template_id'
                :returnObject='true'
                @change='updateTemplate'
                label='Шаблон'
                ref='templateIdPicker'
              )
            v-flex(xs12)
              v-text-field(
                v-model='meta.title'
                label='Заголовок страницы'
                hint='HTML title'
                persistent-hint
              )
            v-flex(xs12)
              v-textarea(
                v-model='meta.description'
                label='Описание'
                hint='HTML description'
                persistent-hint
              )
      template(v-if='contentType === contentTypes.JsonData')
        v-tab Контент страницы
        v-tab-item(:transition='false' :reverse-transition='false')
          template(v-if='schema')
            v-card-text
              v-form(:model="valid")
                editor(:schema="schema" :model="model")
      template(v-else-if='contentType === contentTypes.Html')
        v-tab Контент страницы
        v-tab-item(:transition='false' :reverse-transition='false')
          v-card-text
            ckeditor(v-model='html')
      template(v-else-if='contentType === contentTypes.HtmlData')
        v-tab Контент страницы
        v-tab-item(class="html" :transition='false' :reverse-transition='false')
          v-card-text
            blocks(:blocksList='blocksList' @change='updateBlocks')
  v-card-actions(class='large floating-buttons')
    v-spacer
    s-back-btn
    v-btn(
      :loading='loading'
      @click.native='saveData'
      color='primary'
      depressed
    ) Сохранить
</template>

<script>
// TODO: это пробная версия
import Editor from '@/components/editor/Index'
import http from '@/http'
import { pick } from 'lodash'
import { contentTypes } from '@/enums/content-types'
import Blocks from '@/modules/blocks/components/List'

const metaKeys = [
  'parent_id',
  'name',
  'title',
  'description',
  'url',
  'published',
  'published_at',
  'site_template_id',
  'site_id'
]

export default {
  props: ['id'],

  components: {
    Editor,
    Blocks,
    Ckeditor: () => import('@/components/async/Ckeditor')
  },

  data() {
    return {
      schema: null,
      model: {},
      html: '',
      valid: false,
      loading: false,
      meta: {},
      active: 0,
      contentType: null,
      contentTypes,
      blocksList: []
    }
  },

  created() {
    if (this.id && !this.$route.query.parentId) {
      this.loadData()
    }
  },

  methods: {
    async updateTemplate({ id, json_scheme }) {
      if (
        await this.$confirm(`
          Внимание! Все данные будут утеряны, продолжить ?
      `)
      ) {
        this.meta.site_template_id = id
        this.schema = this._parseResponse(json_scheme)
      }
    },

    async loadData() {
      if (!this.id) {
        return
      }

      try {
        const { data } = await http.get(`/site/tree/${this.id}`)

        switch (data.content_type) {
          case contentTypes.Html:
            this.html = data.site_html
            this.contentType = contentTypes.Html
            break
          case contentTypes.JsonData:
            this.schema = this._parseResponse(data.site_template.json_scheme)
            this.model = this._parseResponse(data.site_template_data)
            this.contentType = contentTypes.JsonData
            break
          case contentTypes.HtmlData:
            this.contentType = contentTypes.HtmlData
            this.blocksList = this._parseResponse(data.site_html_data)
            break
        }

        this.meta = pick(data, metaKeys)
      } catch (e) {
        this.$root.showSnack('Ошибка парсинга модели или схемы')
      }
    },

    async saveData() {
      if (this.loading) return
      this.loading = true

      try {
        let payload

        // TODO: вынести все безобразие с стор
        if (this.contentType === contentTypes.Html) {
          payload = {
            ...this.meta,
            site_html: this.html,
            site_html_data: null,
            site_template_data: null,
            content_type: this.contentType
          }
        } else if (this.contentType === contentTypes.JsonData) {
          payload = {
            ...this.meta,
            site_html: null,
            site_html_data: null,
            site_template_data: JSON.stringify(this.model),
            content_type: this.contentType
          }
        } else if (this.contentType === contentTypes.HtmlData) {
          payload = {
            ...this.meta,
            site_html: null,
            site_template_data: null,
            site_html_data: JSON.stringify(this.blocksList),
            content_type: this.contentType
          }
        }

        if (void 0 === payload) {
          return
        }

        const { parentId } = this.$route.query
        if (parentId) {
          payload.parent_id = parentId
        }

        if (this.id && !this.$route.query.parentId) {
          await http.patch(`/site/tree/${this.id}`, payload)
        } else {
          await http.post(`/site/tree`, payload)
        }

        this.$root.showSnack('Сохранено успешно')
        // this.$router.go(-1)
      } catch (e) {
        this.$root.showSnack('Ошибка сохранения')
      } finally {
        this.loading = false
      }
    },

    async setContentType(id) {
      if (
        await this.$confirm(`
          Внимание! Все данные будут утеряны, продолжить ?
      `)
      ) {
        this.contentType = id
        this.meta.site_template_id = null
      }
    },

    updateBlocks(blocks) {
      this.blocksList = blocks
    },

    _parseResponse(response) {
      try {
        return JSON.parse(response)
      } catch (e) {
        throw e
      }
    }
  }
}
</script>

<style scoped>
.html {
  background: #f6faf8;
}
.floating-buttons {
    position: fixed;
    top: 75px;
    right: 0px;
}
</style>
